<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات تور"
        >
          <b-form
            ref="tourform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="8">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="دسته بندی"
                      label-for="TourCategoryId"
                    >
                      <z-tour-category
                        v-model="Form.TourCategoryId"
                        :multiple="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        name="IsActive"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="هتل"
                      label-for="HotelId"
                    >
                      <z-hotel
                        v-model="Form.HotelId"
                        :multiple="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="دو تخته"
                      label-for="DoublePrice"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.DoublePrice"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="یک تخته"
                      label-for="SinglePrice"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.SinglePrice"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="سه تخته"
                      label-for="TriplePrice"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.TriplePrice"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="کودک با تخت"
                      label-for="ChildWithBedPrice"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.ChildWithBedPrice"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="کودک بدون تخت"
                      label-for="ChildWithoutBedPrice"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.ChildWithoutBedPrice"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="نوزاد"
                      label-for="InfantPrice"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.InfantPrice"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1 mb-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.IsSpecial"
                        name="IsSpecial"
                        value="true"
                        class="custom-control-success"
                      >
                        تور ویژه می باشد.
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        برنامه سفر
                      </div>
                    </div>
                  </b-col>

                  <template
                    v-for="(item, index) in Form.TourItinerary"
                  >
                    <!--                    <b-row>-->
                    <b-col md="4">
                      <b-form-group
                        label="از مبدا"
                        label-for="StartDate"
                      >
                        <z-city v-model="item.OriginId" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        label="تاریخ"
                        label-for="StartDate"
                      >
                        <date-picker
                          v-model="item.DepartureDate"
                          placeholder=""
                          format="YYYY-MM-DD"
                          :clearable="true"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group
                        label="زمان"
                        label-for="StartDate"
                      >
                        <date-picker
                          v-model="item.DepartureTime"
                          placeholder=""
                          type="time"
                          format="YYYY-MM-DD HH:mm"
                          display-format="HH:mm"
                          :clearable="true"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group
                        label="به مقصد"
                        label-for="StartDate"
                      >
                        <z-city v-model="item.DestinationId" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        label="تاریخ"
                        label-for="StartDate"
                      >
                        <date-picker
                          v-model="item.ArrivalDate"
                          placeholder=""
                          format="YYYY-MM-DD"
                          :clearable="true"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group
                        label="زمان"
                        label-for="StartDate"
                      >
                        <date-picker
                          v-model="item.ArrivalTime"
                          placeholder=""
                          type="time"
                          format="YYYY-MM-DD HH:mm"
                          display-format="HH:mm"
                          :clearable="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <div class="divider divider-solid" />
                    </b-col>
                    <!--                    </b-row>-->
                  </template>

                  <b-col class="mb-2">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addTourItinerary"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        نظرات
                      </div>
                    </div>
                  </b-col>

                  <template
                    v-for="(item, index) in Form.TourComment"
                  >
                    <b-col md="5">
                      <b-form-group
                        label="نام نویسنده"
                      >
                        <b-form-input
                          v-model="item.Author"
                          autocomplete="off"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="3">
                      <b-form-group
                        label="امتیاز"
                      >
                        <v-select
                          v-model="item.Rating"
                          :options="[1, 2, 3, 4, 5]"
                          dir="rtl"
                          :clearable="false"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group
                        label="تاریخ"
                      >
                        <date-picker
                          v-model="item.Date"
                          placeholder=""
                          format="YYYY-MM-DD"
                          :clearable="true"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="11">
                      <b-form-group
                        label="متن نظر"
                      >
                        <b-form-textarea
                          v-model="item.Text"
                          rows="2"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col
                      md="1"
                      class="d-flex align-items-center"
                    >
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="gradient-danger"
                        class="btn-icon"
                        @click="removeTourComment(index)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </b-col>

                    <b-col cols="12">
                      <div class="divider divider-solid" />
                    </b-col>
                  </template>

                  <b-col class="mb-2">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addTourComment"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن نظر</span>
                    </b-button>
                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                  <!--                </template>-->
                </b-row></b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-if="isShowModal"
      v-model="isShowModal"
      ok-title="ذخیره"
      centered
      ok-only
      title="عنوان تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveModal"
    >
      <b-row class="mt-1">
        <b-col md="12">
          <b-form-group>
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
              autofocus
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </b-overlay>
</template>

<script>

import ZQuillEditor from '@/tools/quilleditor.vue'
import ZTourCategory from '@/tools/tourcategory.vue'
import ZHotel from '@/tools/hotel.vue'
import ZCity from '@/tools/city.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'HotelDetails',
  components: {
    ZCity, ZHotel, ZTourCategory, ZQuillEditor, ZSeo,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Subtitle: null,
        Image: null,
        Description: null,
        IsActive: true,
        Slug: null,
        MetaTitle: null,
        ImageAlt: null,
        MetaDescription: null,
        MetaKeywords: null,
        Date: null,
        Time: null,
        IsSpecial: false,
        TourItinerary: [],
        TourComment: [],
      },
      loading: false,
      isShowModal: false,
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.tour.add
      if (this.$route.params.id) {
        url = this.$api.tour.update
      }

      // به‌دلیل آپلود فایل ویدئو، فرم به صورت multipart/form-data ارسال می‌شود
      const formData = new FormData()

      if (this.Form.Id) {
        formData.append('Id', this.Form.Id)
      }

      formData.append('Title', this.Form.Title ?? '')
      formData.append('IsActive', this.Form.IsActive)
      formData.append('IsSpecial', this.Form.IsSpecial)

      if (this.Form.TourCategoryId) {
        formData.append('TourCategoryId', this.Form.TourCategoryId)
      }

      if (this.Form.HotelId) {
        formData.append('HotelId', this.Form.HotelId)
      }

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.MetaTitle) {
        formData.append('MetaTitle', this.Form.MetaTitle)
      }

      if (this.Form.MetaDescription) {
        formData.append('MetaDescription', this.Form.MetaDescription)
      }

      if (this.Form.MetaKeywords) {
        formData.append('MetaKeywords', this.Form.MetaKeywords)
      }

      if (this.Form.ImageAlt) {
        formData.append('ImageAlt', this.Form.ImageAlt)
      }

      if (this.Form.Video instanceof File) {
        formData.append('Video', this.Form.Video)
      }

      const prices = []
      if (this.Form.SinglePrice) prices.push({ Type: 1, Price: String(this.Form.SinglePrice).replaceAll(',', '') })
      if (this.Form.DoublePrice) prices.push({ Type: 2, Price: String(this.Form.DoublePrice).replaceAll(',', '') })
      if (this.Form.TriplePrice) prices.push({ Type: 3, Price: String(this.Form.TriplePrice).replaceAll(',', '') })
      if (this.Form.ChildWithBedPrice) prices.push({ Type: 4, Price: String(this.Form.ChildWithBedPrice).replaceAll(',', '') })
      if (this.Form.ChildWithoutBedPrice) prices.push({ Type: 5, Price: String(this.Form.ChildWithoutBedPrice).replaceAll(',', '') })
      if (this.Form.InfantPrice) prices.push({ Type: 6, Price: String(this.Form.InfantPrice).replaceAll(',', '') })

      prices.forEach((item, index) => {
        formData.append(`TourPrice[${index}].Type`, item.Type)
        formData.append(`TourPrice[${index}].Price`, item.Price)
      })

      const itineraries = this.Form.TourItinerary
          .filter(item => !(
              (item.OriginId == null || item.OriginId === '') &&
              (item.DestinationId == null || item.DestinationId === '') &&
              (item.DepartureDate == null || item.DepartureDate === '') &&
              (item.DepartureTime == null || item.DepartureTime === '') &&
              (item.ArrivalDate == null || item.ArrivalDate === '') &&
              (item.ArrivalTime == null || item.ArrivalTime === '')
          ))
          .map(item => ({
            OriginId: item.OriginId,
            DestinationId: item.DestinationId,
            Departure: `${this.$moment(item.DepartureDate).format('YYYY-MM-DD')} ${this.$moment(item.DepartureTime).format('HH:mm')}`,
            Arrival: `${this.$moment(item.ArrivalDate).format('YYYY-MM-DD')} ${this.$moment(item.ArrivalTime).format('HH:mm')}`,
            Description: item.Description,
          }))

      itineraries.forEach((item, index) => {
        formData.append(`TourItinerary[${index}].OriginId`, item.OriginId)
        formData.append(`TourItinerary[${index}].DestinationId`, item.DestinationId)
        formData.append(`TourItinerary[${index}].Departure`, item.Departure)
        formData.append(`TourItinerary[${index}].Arrival`, item.Arrival)
        if (item.Description) {
          formData.append(`TourItinerary[${index}].Description`, item.Description)
        }
      })

      const comments = (this.Form.TourComment || [])
        .filter(item => item.Author || item.Text)
        .map(item => ({
          Author: item.Author,
          Text: item.Text,
          Rating: item.Rating || 0,
          Date: item.Date ? this.$moment(item.Date).format('YYYY-MM-DD') : null,
        }))

      comments.forEach((item, index) => {
        formData.append(`TourComment[${index}].Author`, item.Author ?? '')
        formData.append(`TourComment[${index}].Text`, item.Text ?? '')
        formData.append(`TourComment[${index}].Rating`, item.Rating)
        if (item.Date) {
          formData.append(`TourComment[${index}].Date`, item.Date)
        }
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.tour.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Form.SinglePrice = this.Form.TourPrice.filter(x => x.Type == 1)[0]?.Price
          this.Form.DoublePrice = this.Form.TourPrice.filter(x => x.Type == 2)[0]?.Price
          this.Form.TriplePrice = this.Form.TourPrice.filter(x => x.Type == 3)[0]?.Price
          this.Form.ChildWithBedPrice = this.Form.TourPrice.filter(x => x.Type == 4)[0]?.Price
          this.Form.ChildWithoutBedPrice = this.Form.TourPrice.filter(x => x.Type == 5)[0]?.Price
          this.Form.InfantPrice = this.Form.TourPrice.filter(x => x.Type == 6)[0]?.Price

          this.Form.TourItinerary = this.Form.TourItinerary.map(item => ({
            OriginId: item.OriginId,
            DestinationId: item.DestinationId,
            DepartureDate: item.Departure,
            DepartureTime: item.Departure,
            ArrivalDate: item.Arrival,
            ArrivalTime: item.Arrival,
            Description: item.Description,
          }))

          this.Form.TourComment = (this.Form.TourComment || []).map(item => ({
            Author: item.Author,
            Text: item.Text,
            Rating: item.Rating,
            Date: item.Date,
          }))
        })
    },
    showModal(row) {
      this.isShowModal = true
      this.row = row
    },
    saveModal() {
      this.isShowModal = false
    },
    addTourItinerary() {
      this.Form.TourItinerary.push({
        OriginId: null, DestinationId: null, DepartureDate: null, DepartureTime: null, ArrivalDate: null, ArrivalTime: null,
      })
    },
    addTourComment() {
      this.Form.TourComment.push({
        Author: null, Text: null, Rating: 5, Date: null,
      })
    },
    removeTourComment(index) {
      this.Form.TourComment.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
